import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import HomeSliderIntro from './components/HomeSliderIntro'
import store from '../shared/store'


const homeIntroSlider = () => {
  const el = document.querySelector('.home-intro-slider')

  render(
    <Provider store={store}>
      <HomeSliderIntro />
    </Provider>,
    el,
  )
}

export default homeIntroSlider
